import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';
export class LogoutAction extends ba.Action {
    static get manifest() {
        return {
            name: 'logout',
            schema: z.object({})
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        return event.component.$app.auth.logout();
    }
}
//# sourceMappingURL=logout.js.map